module.exports = __webpack_public_path__ + "static/media/YM56_3.44046c69.jpg";